import React, { useCallback } from 'react';
import { TTypeOfModalWindow } from '../../../../../editDeviceState/editDeviceContext';
import { FileSection } from 'components/UploaderAndDownloader/FileSection';
import style from './TlsFileSection.module.scss';

interface IProps {
	setTlsCertificateFile: ({ fileId, fileHash }: { fileId: Nullable<string>; fileHash: Nullable<string> }) => void;
	changeTypeOfModalWindow: (value: TTypeOfModalWindow) => void;
	tlsCertificateFileId: Nullable<string>;
	tlsCertificateFilePath: Nullable<string>;
}

const TlsFileSection: React.FC<IProps> = ({
	setTlsCertificateFile,
	changeTypeOfModalWindow,
	tlsCertificateFileId,
	tlsCertificateFilePath,
}) => {
	const handleDeleteFileId = useCallback(() => {
		setTlsCertificateFile({ fileId: null, fileHash: null });
	}, [setTlsCertificateFile]);

	const handleFileSizeError = useCallback(() => {
		changeTypeOfModalWindow('tlsFileSizeExceeded');
	}, [changeTypeOfModalWindow]);

	const handleFileTypeError = useCallback(() => {
		changeTypeOfModalWindow('tlsFileTypeError');
	}, [changeTypeOfModalWindow]);

	return (
		<FileSection
			onUploadFile={setTlsCertificateFile}
			onDeleteFile={handleDeleteFileId}
			onSizeError={handleFileSizeError}
			onFileTypeError={handleFileTypeError}
			fileId={tlsCertificateFileId}
			filePath={tlsCertificateFilePath}
			className={style.container}
			fileName="certificate.p12"
			accept={['p12']}
		/>
	);
};

export default React.memo(TlsFileSection);
